var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreedAreaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 33.2513L8.05178 80H71.0885L72 33.2513C63.7961 29.1037 66.6957 14.8137 68.0032 6.6239L50.4736 1C49.0011 6.5536 48.6505 14.2004 39.0442 14.2004C30.8996 14.2004 29.7449 6.10228 28.1758 1L10.9968 6.9754C14.3625 28.065 10.9968 30.5097 7 33.2513Z",
    fill: "#E1E1E2",
    stroke: "#303238"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 35.5563L14.6735 73H64.3878L65 35.5563C58.9265 32.4374 60.449 20.9462 61.4694 14.5905L52.455 12C51.2305 16.8125 47.9796 23.9362 38.6122 23.8753C31.0816 23.8263 26.791 15.9596 25.5665 12L17.5306 14.5905C19.5388 30.429 16.3469 34.5004 14 35.5563Z",
    stroke: "#0F9D58",
    strokeOpacity: 0.32,
    strokeDasharray: "3 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 38.2724L17.5942 70H61.4598L62 38.2724C56.6411 35.3135 57.102 25.5146 58.0024 19.485L52.7622 18C51.6818 22.5655 46.7592 28.4206 38.4939 28.3628C31.8492 28.3163 26.2817 21.7564 25.2012 18L20.9976 19.485C22.7695 34.5108 19.0708 37.2707 17 38.2724Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreedAreaIcon);
export default __webpack_public_path__ + "static/media/breed-area-icon.892322ed7587a6a1cfd6ae1e38f35c42.svg";
export { ForwardRef as ReactComponent };